/**
 *
 * @file simpleOauth
 *
 * @module simpleOauth
 *
 */

import $ from 'jquery';

(function($) {
  'use strict';

  var config = {
    submitBtn : 'fpi-cta fpi-cta--redInvert',
    submitSimpleOauth : '#edit-submit',
    formSimpleOauth : '#simple_oauth_authorize_form',
  }

  function modifyButton() {
    if ($(config.formSimpleOauth) && $(config.submitSimpleOauth).val() === 'Grant') {
      $(config.submitSimpleOauth).css('margin-top', '5px');
      $(config.submitSimpleOauth).addClass(config.submitBtn);
      $(config.submitSimpleOauth).val('Cliquez ici pour partager vos identifiants');
    }
  }

  $(document).ready(function() {
    modifyButton();
  });

})($);



// WEBPACK FOOTER //
// ./src/js/simpleOauth.js